import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";

import ListHeader from "../list/ListHeader";
import DuplicateTableUI from "../list/DuplicateTableUI";
import FilterPannel from "../filter/FilterPannel";
import withRouter from '../../util/WithRouter';
import Const from "../../util/Constants";
import Util from "../../util/Util";
import Display from "../../util/Display";
import LeadAPI from "../../api/LeadAPI";
import ViewController from "../../controller/ViewController";

class LeadList extends React.Component {
  constructor(props) {
    super(props);

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    this.setList();

    this.leads = { data: [], count: 0 };
    this.state = { massUpdate: false, massEmail: false, massSMS: false, inApiCall: true, isFilterOpen: false };

    this.selected = [];
  }

  componentDidMount() { 
    if (this.List) { 
      this.loadLeads(); 
    } 
  }

  setList = () => {
    const fields = [ ];
    if(this.model.fields['firstname'] && this.model.fields['firstname'].visible === Const.True) {
      fields.push('firstname');
    }
    if(this.model.fields['middlename'] && this.model.fields['middlename'].visible === Const.True) {
      fields.push('middlename');
    }
    if(this.model.fields['lastname'] && this.model.fields['lastname'].visible === Const.True) {
      fields.push('lastname');
    }
    const Keys = Object.keys(this.model.fields);
    for(let i = 0; i < Keys.length; i++) {
      if(this.model.fields[Keys[i]].non_duplicate === Const.True && !fields.includes(Keys[i])) {
        fields.push(Keys[i]);
      }
    }
    fields.push('duplicate');

    const filters = [];
    const pagination = { currentPage: 1, perPage: 10 };
    const sorting = { field: 'id', order: -1 };
    this.list = { fields, filters, pagination, sorting };
  }

  loadLeads = () => {
    const filters = ViewController.filters( [...this.list.filters], [], this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    LeadAPI.duplicate({ ...this.list, filters }, this.onReceived, this.onFail);
  };

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  
  onReceived = res => {
    this.leads = res;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadLeads();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadLeads();
  }

  showMassDelete = () => {
    if(this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please select leads', 'danger');
    } else {
      Util.confirmAlert('Delete', `Are you sure you want to mass delete (${this.selected.length}) leads ?`, 
        'Mass Delete', 'No', () => {
          this.setState({ ...this.state, inApiCall: true });
          LeadAPI.massDelete(this.list, this.selected, this.onMassDeleted, this.onFail);
        });
    }
  }
  onMassDeleted = () => {
    Util.showNotification('Successful', 'Lead Mass Deleted successfull.', 'success');
    this.selected = [];
    this.loadLeads();
  }

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  onFilterChange = filters => {
    this.list.pagination.currentPage = 1;
    this.list.filters = filters;
    this.loadLeads();
  };

  onAddEdit = lead => this.props.navigate(`lead/preview/add-edit/${lead.id}`);
  onPreview = (lead, control) => {
    if(control) {
      window.open(`lead/preview/${lead.id}`, '_blank');
    } else {
      this.props.navigate(`/lead/preview/${lead.id}`);
    }
  }
  onDelete = lead => Util.confirmAlert('Delete', `Are you sure you want to delete to` 
    + ` ${Display.ModelName(lead)}`, 'Delete', 'No',
    () => {
      this.setState({ ...this.state, inApiCall: true });
      LeadAPI.delete(lead.id,this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Lead deleted successfully', 'success');
    this.loadLeads();
  };

  onSelect = id => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = id => {
    this.selected = this.selected.filter((item) => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = index => {
    if(index !== -1) {
      for(let i = 0; i < this.leads.data.length; i++) {
        if(index < this.leads.data[i].duplicate.length) {
          this.selected.push(this.leads.data[i].duplicate[index].id)
        }
      }
    }
  };
  onRemoveAll = index => {
    if(index !== -1) {
      for(let i = 0; i < this.leads.data.length; i++) {
        if(index < this.leads.data[i].duplicate.length) {
          this.selected = this.selected.filter(item => item !== this.leads.data[i].duplicate[index].id);
        }
      }
    }
  };

  render() {
    if (!this.List) return null;
    return (
      <div>        
        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.leads.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => {}}
          add={false}
          import={false}
          export={false}
          update={this.update}
          showMassUpdate={false}
          showMassDelete={this.showMassDelete}
          showMassEmail={false}
          showMassSMS={false}
        />

        <div className="container-fluid ">
          <div className="row">
            <DuplicateTableUI
              data={this.leads.data}
              duplicateCount={this.leads.ref ? this.leads.ref : 1}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              isFilterOpen={this.state.isFilterOpen}
              onSelectAll={this.onSelectAll}
              onRemoveAll={this.onRemoveAll}
              onSelect={this.onSelect}
              onRemove={this.onRemove}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              view={this.view}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadList);
